// extracted by mini-css-extract-plugin
export default {"button":"Button_button__h-PxG","solid":"Button_solid__Vmot-","soft":"Button_soft__iO3c4"};